import styled from 'styled-components';
import { IoClose } from 'react-icons/io5';

import {
  subMenuDropdownBackground,
  primaryColorLight,
  primaryColorWeak,
} from '../../config/colors';
import Button from '../Button';

export const OtherRelevantDocumentsWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${subMenuDropdownBackground};
  padding: 55px 35px 100px 25px;
`;

export const TableWrapper = styled.div`
  width: 100%;
  table {
    width: 100%;
    text-align: center;
    border-spacing: 0;
    border-collapse: collapse;
    table-layout: fixed;
    word-break: break-word;
  }
  tbody {
    background-color: white;
  }
  td,
  th {
    border: 2px solid ${primaryColorLight};
  }
  th {
    padding: 10px;
    background-color: ${primaryColorWeak};
  }
  th:last-child {
    border: 0px;
    background-color: ${subMenuDropdownBackground};
  }
  tr {
    th:last-child,
    td:last-child {
      width: 4%;
      border: 0px;
      background-color: ${subMenuDropdownBackground};
    }
  }
  @media print {
    table {
      th,
      td {
        padding: 7px;
        overflow: hidden;
      }
    }
  }
`;

export const RemoveRowBtn = styled(Button).attrs({
  wrapperStyle: {
    width: '25px',
    height: '25px',
    marginLeft: '5px',
  },
  type: 'rounded',
  icon: IoClose,
  iconProps: {
    color: 'white',
    size: '16px',
  },
})``;

export const AddNewRowBtn = styled(Button).attrs({
  wrapperStyle: {
    width: '60%',
    height: '40px',
    alignSelf: 'center',
    marginTop: '20px',
  },
  textStyle: {
    fontSize: '1rem',
  },
})``;
